import { NgModule } from '@angular/core';

import { ButtonComponent } from './button.component';

@NgModule({
  declarations: [
    ButtonComponent,
  ],
  exports: [
    ButtonComponent,
  ],
  providers: [],
})
export class ButtonModule { }



// WEBPACK FOOTER //
// ./src/app/common/components/ButtonComponent/button.module.ts